.container {
    display: flex;
    align-items: center;
}

.tooltipContainer {
    margin-left: 4px;
}

.underScore {
    word-break: break-all;
}